'use es6';

import { EMPTY_OBJECT } from "../../../internal/@base-ui/utils/empty";

/**
 * Maps a change `reason` string to the corresponding native event type.
 */

/**
 * Details of custom change events emitted by Base UI components.
 */

/**
 * Details of custom generic events emitted by Base UI components.
 */

/** Highlight navigation uses mouse events for hover and pointer events for leaving an item. */

/**
 * Creates a Base UI event details object with the given reason and utilities
 * for preventing Base UI's internal event handling.
 */
export function createChangeEventDetails(reason, event, trigger, customProperties) {
  let canceled = false;
  let allowPropagation = false;
  const custom = customProperties !== null && customProperties !== void 0 ? customProperties : EMPTY_OBJECT;
  const details = Object.assign({
    reason,
    event: event !== null && event !== void 0 ? event : new Event('base-ui'),
    cancel() {
      canceled = true;
    },
    allowPropagation() {
      allowPropagation = true;
    },
    get isCanceled() {
      return canceled;
    },
    get isPropagationAllowed() {
      return allowPropagation;
    },
    trigger
  }, custom);
  return details;
}
export function createGenericEventDetails(reason, event, customProperties) {
  const custom = customProperties !== null && customProperties !== void 0 ? customProperties : EMPTY_OBJECT;
  const details = Object.assign({
    reason,
    event: event !== null && event !== void 0 ? event : new Event('base-ui')
  }, custom);
  return details;
}